import { Dictionary } from '@skylab-shared/types';

export enum ViolationSeverity {
    Error = 1,
    Warning = 2,
    Info = 3
}

export type ValidationKind = 'errors' | 'warnings' | 'info';
export type ProcessedValidationResult = Dictionary<{ errors: string[]; warnings: string[]; info: string[] }>;
export type ProcessedReadonlyResult = Dictionary<boolean>;
export type ProcessedRequiredResult = Dictionary<boolean>;

export type ViolationResults = {
    validationResult: ProcessedValidationResult;
    readonlyResult: ProcessedReadonlyResult;
    requiredResult: ProcessedRequiredResult;
};

export type ViolationForKey = {
    errors: string[];
    warnings: string[];
    info: string[];
    readonly: boolean;
    required: boolean;
};

export interface ViolationWithMessage {
    messages: string[];
    validationKey: string;
}

export interface ViolationWithValue {
    value: boolean;
    validationKey: string;
}

export class Violation {
    public constructor( public readonly severity: ViolationSeverity,
                        public readonly message: string,
                        public readonly messageParams?: unknown) {

    }
}
